import PropTypes from 'prop-types'
import React from 'react'
import { Scrollbars } from 'react-custom-scrollbars'
import { Button, ListItem, NavigationBody } from './theme'

const NavigationItem = ({ icon: Icon, children, title, toggle, isToggled, withoutPadding = false }) => (
  <ListItem isToggled={isToggled}>
    <Button onClick={toggle}>
      {Icon && <Icon />} {title}
    </Button>
    {isToggled === true && (
      <NavigationBody withoutPadding={withoutPadding}>
        <Scrollbars autoHide={true} autoHeight={true} autoHeightMax={400}>
          {children}
        </Scrollbars>
      </NavigationBody>
    )}
  </ListItem>
)

NavigationItem.propTypes = {
  title: PropTypes.string.isRequired,
  toggle: PropTypes.func.isRequired,
  isToggled: PropTypes.bool,
  withoutPadding: PropTypes.bool,
}

NavigationItem.defaultProps = {
  isToggle: false,
}

export default NavigationItem



// WEBPACK FOOTER //
// ./src/components/NavigationItem/index.js